import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden auto',
    marginTop: '-1rem',
    marginLeft: '-0.5rem',
    marginRight: '-0.5rem',
    width: '100%',
    height: '100%',
    padding: '0.5rem'
  }
}))

export default useStyles
